import { colors } from "../../Styles";

export function Error({size = "20px", fillColor = colors.greyLightTertiary}) {
  return (
    <svg height={size} width={size} fill={fillColor} xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 283.46 283.46">
      <path d="M141.73,8.29C68.15,8.29,8.29,68.15,8.29,141.73s59.86,133.45,133.45,133.45h0c73.58,0,133.45-59.86,133.45-133.45S215.32,8.29,141.73,8.29ZM141.73,250.09c-59.74,0-108.36-48.61-108.36-108.36s48.6-108.36,108.36-108.36,108.36,48.61,108.36,108.36-48.61,108.36-108.36,108.36Z"/>
      <polygon points="189.74 75.98 141.73 123.99 93.72 75.98 75.98 93.72 123.99 141.73 75.98 189.74 93.72 207.49 141.73 159.48 189.74 207.49 207.49 189.74 159.48 141.73 207.49 93.72 189.74 75.98"/>
    </svg>
  );
}
